export class PopUpHelper {
  static popUpBlockerOn(popUpWindow: any): boolean {
    const that = this;
    if (popUpWindow) {
      if(/chrome/.test(navigator.userAgent.toLowerCase())){
        try {
          popUpWindow.focus();
        } catch (e) {
          return true;
        }
      } else {
        popUpWindow.onload = () => {
          return that.isPopUpBlocked(popUpWindow);
        };
      }
    } else {
      return true;
    }

    return false;
  }

  private static isPopUpBlocked (popUpWindow: any){
    return popUpWindow.innerHeight <= 0;
  }
}